import { useContext } from "react";
import { styled } from "@mui/material/styles";
import ListItem from "@mui/material/ListItem";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { ComponentPropsContext, ComponentPropsContextApi } from "layouts/Flow Designer/context";

const CheckboxFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  padding: "1rem 0",
  "& .MuiTypography-root": {
    fontSize: "16px !important",
    fontWeight: "normal !important",
    color: theme.palette.text.primary,
    marginTop: "0.8rem"
  }
}));

const styles = {
  lblSwitcher: {
    width: "100%"
  }
};

const CheckboxListItem = ({ action, fieldValue, allowEditWorkflow }) => {
  const { actionForm } = useContext(ComponentPropsContext);
  const { setActionForm } = useContext(ComponentPropsContextApi);

  const handleSwitchChange = (e) => {
    const { name } = e.target;
    setActionForm({ ...actionForm, [name]: { ...actionForm[name], value: e.target.checked } });
  };

  return (
    <ListItem key={action.label}>
      <CheckboxFormControlLabel
        name={action.field}
        label={action.label}
        sx={{ ...styles.lblSwitcher, marginLeft: 0 }}
        control={
          <Checkbox
            checked={!!fieldValue}
            disabled={action.disabled || !allowEditWorkflow}
            onChange={handleSwitchChange}
            className="flow-designer-cbx"
          />
        }
      />
    </ListItem>
  );
};

export default CheckboxListItem;
